import { render, staticRenderFns } from "./AnimatedSection.vue?vue&type=template&id=33bafb38&scoped=true"
import script from "./AnimatedSection.vue?vue&type=script&lang=js"
export * from "./AnimatedSection.vue?vue&type=script&lang=js"
import style0 from "./AnimatedSection.vue?vue&type=style&index=0&id=33bafb38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bafb38",
  null
  
)

export default component.exports